import React from 'react'
import { change, store, success as changeSuccess } from '../../../store/actions/notification.action'
import { TextField, AppBar, Toolbar, IconButton, Typography, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, InputAdornment } from '@material-ui/core'
import { FaSave } from 'react-icons/fa'
import { MdDelete, MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen } from '../../../store/actions/navigation.action'
import { changeAlert } from '../../../store/actions/alert.action'
import { domain } from '../../../config/App'

const NotificationCreate = () => {
    const dispatch = useDispatch()
    const { notification, error } = useSelector(state => state.notificationReducer)

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _store = () => {
        dispatch(store(notification))
    }

    const handleChange = async (index) => {
        const value = await navigator.clipboard.readText()
        const domains = ["fulldevs-test.com.br", "fulldevs.com.br"]
        const domainRegex = new RegExp(`https?:\\/\\/(?:www\\.)?(?:${domains.join("|")})[^\\s]*`, "gi")
        const found = value.match(domainRegex)

        if (found && found.length > 0) {
            const detectedLink = found[0]

            dispatch(change({ 
                buttons: [
                    {
                        type: 'CALL',
                        url: detectedLink,
                        label: notification.buttons[index].label
                    }
                ]
            }))
        }else {
            dispatch(changeAlert({
                open: true,
                msg: 'Somente links do seu site são permitidos',
                class: 'warning'
            }))

            dispatch(change({ 
                buttons: [
                    {
                        type: 'CALL',
                        url: '',
                        label: notification.buttons[index].label
                    }
                ]
            }))
        }
    }

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        Nova Notificação
                    </Typography>

                    <Button onClick={() => _store() } color="inherit" className="ms-auto">
                        <FaSave className="me-2" /> Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="card card-body mt-3 bs-bg">
                <div className="mb-3">
                    <FormControl component="fieldset">
                        <FormLabel className="bs-color" component="legend">Tipo</FormLabel>
                        <RadioGroup 
                            aria-label="status_detail" 
                            name="status_detail" 
                            value={notification.is_poll || 0} 
                            onChange={ e => dispatch(change({ is_poll: parseInt(e.target.value) }))}
                            className="fw-normal bs-color-b"
                        >
                            <FormControlLabel value={0} control={<Radio color="primary" />} label="Mensagem" />
                            <FormControlLabel value={1} control={<Radio color="primary" />} label="Enquete" />
                        </RadioGroup>
                    </FormControl>
                </div>

                <div className="mb-3">
                    <label className="label-custom bs-color-b">Titúlo</label>
                    <TextField
                        error={(error.notification_title) && true}
                        value={notification.notification_title || ''}
                        onChange={text => {
                            dispatch(change({ notification_title: text.target.value }))
                            if (error.notification_title && delete error.notification_title);
                        }}
                    />

                    {(error.notification_title) &&
                        <strong className="text-danger">{error.notification_title[0]}</strong>
                    }
                </div>

                <div className="mb-3">
                    <label className="label-custom bs-color-b">Subtítulo</label>
                    <TextField
                        error={(error.notification_subtitle) && true}
                        value={notification.notification_subtitle || ''}
                        onChange={text => {
                            dispatch(change({ notification_subtitle: text.target.value }))
                            if (error.notification_subtitle && delete error.notification_subtitle);
                        }}
                    />

                    {(error.notification_subtitle) &&
                        <strong className="text-danger">{error.notification_subtitle[0]}</strong>
                    }
                </div>
            </div>

            <div className="card card-body mt-3 bs-bg mb-4">

                {!notification.is_poll ?
                    <>
                    <div className="mb-3">
                        <label className="label-custom bs-color-b">Mensagem</label>
                        <TextField
                            multiline
                            error={(error.body) && true}
                            value={notification.body || ''}
                            minRows={4}
                            onChange={text => {
                                dispatch(change({ body: text.target.value }))
                                if (error.body && delete error.body);
                            }}
                        />

                        {(error.body) &&
                            <strong className="text-danger">{error.body[0]}</strong>
                        }
                    </div>

                    <label className="label-custom bs-color-b">Botão de Ação</label>
                    
                    {notification.buttons.map((item, index) => (
                        <React.Fragment key={index}>
                            <div className="mb-3">
                                <TextField
                                    value={item.url || ''}
                                    placeholder={'Ex: ' +domain}
                                    onChange={e => handleChange(e, index)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                {notification.buttons[index].url &&
                                                    <IconButton onClick={() => {
                                                        dispatch(change({ 
                                                            buttons: [
                                                                {
                                                                    type: 'CALL',
                                                                    url: '',
                                                                    label: notification.buttons[index].label
                                                                }
                                                            ]
                                                        }))
                                                    }}>
                                                        <MdDelete className="text-muted" />
                                                    </IconButton>
                                                }
                                                <Button onClick={() => handleChange(index)} variant="contained" size="small" className="btn-paste">
                                                    colar
                                                </Button>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <TextField
                                    value={item.label || ''}
                                    placeholder='Texto do botão ex: Quero Participar'
                                    onChange={e => {
                                        dispatch(change({ 
                                            buttons: [
                                                {
                                                    type: 'CALL',
                                                    url: notification.buttons[index].url,
                                                    label: e.target.value
                                                }
                                            ]
                                         }))
                                    }}
                                    
                                />
                            </div>
                        </React.Fragment>
                    ))}
                    </>
                :
                <>
                    <div className="mb-3">
                        <label className="label-custom bs-color-b">Pergunta</label>
                        <TextField
                            error={(error.question) && true}
                            value={notification.question || ''}
                            placeholder="Faça uma pergunta"
                            onChange={text => {
                                dispatch(change({ question: text.target.value }))
                                if (error.question && delete error.question);
                            }}
                        />

                        {(error.question) &&
                            <strong className="text-danger">{error.question[0]}</strong>
                        }
                    </div>
                </>
                }

            </div>
        </div>
    )
}

export default NotificationCreate